import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { TimeoutError } from 'rxjs';
import { EventsService } from '../events/events.service';
import { ToastControllerWrapperService } from '../toast-controller-wrapper/toast-controller-wrapper.service';
import { UserDataService } from '../user-data/user-data.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {

  ERROR_SENDING_EMAIL_STRING: string = 'Error sending email';
  constructor(private userData: UserDataService,
    private toastWrapper: ToastControllerWrapperService,
    private router: Router,
    private eventsService: EventsService,
    private alertController: AlertController
  ) { }

  async handleError(httpError: HttpErrorResponse) {

    if (httpError instanceof TimeoutError) {
      this.toastWrapper.presentErrorToast('Timeout occured. Server could not be found.');
    }
    else {

      if (httpError.status === 0) {
        // client-side or network error
        switch (httpError.statusText) {
          case 'Unknown Error':
            this.toastWrapper.presentErrorToast('Could not find server.');
            break;
        }
      }
      else {
        // back-end error
        switch (httpError.status) {
          case 302:
            // Special case. mfq_recommendationItemController.Create returns HTTP code 302 when there are questions associated to the inventory item so ignore it
            break;
          case 400:
          case 403:
            if (httpError.error && httpError.error.message && !httpError.error.type) {
              this.toastWrapper.presentErrorToast(httpError.error.message);
            }
            else if (httpError.error && httpError.error.type == 'application/json') {
                httpError.error.text().then(text => {
                  let apiResponse = JSON.parse(text);
                  if (apiResponse.payload && apiResponse.payload.error && apiResponse.payload.error.Message) {
                    this.toastWrapper.presentErrorToast(apiResponse.payload.error.Message);
                  } else if (apiResponse.message) {
                    this.toastWrapper.presentErrorToast(apiResponse.message);
                  }
                  else {
                    this.toastWrapper.presentErrorToast('An unknown error occured, please contact administration.');
                  }
                });
            }
            else{
              this.toastWrapper.presentErrorToast(httpError.message);
            }
            break;
          case 401:
            if (await(this.userData.hasLoggedIn())) {
              await this.userData.removeLoginData();
              this.eventsService.publishLogout();
              await this.router.navigate(['/login']);
              this.toastWrapper.presentErrorToast('There was an authorization error, possibly due to your app out of date and does not match the server.');
            }
            break;
          case 404:
            this.toastWrapper.presentErrorToast('Could not find server.');
            break;
          case 408:
            this.toastWrapper.presentErrorToast('Timeout occured. Server could not be found.');
            break;
          case 409:
            this.toastWrapper.presentErrorToast(httpError.error);
            break;
          case 500:
            this.toastWrapper.presentErrorToast(httpError.statusText);
            break;
          default:
            this.toastWrapper.presentErrorToast('An unknown error occured, please contact administration.');
            break;
        }
      }
    }
  }

  async displayErrorAsDialog(errorHeader: string, errorMessage: string, allowBackdropDismiss: boolean = false) {
    const msgDialog = await this.alertController.create({
      backdropDismiss: allowBackdropDismiss,
      header: errorHeader,
      message: errorMessage,
      buttons: [
        {
          text: 'OK',
          role: 'confirm',
          handler: () => {
            msgDialog.dismiss();
          }
        }
      ]
    });
    await msgDialog.present();
  }
}
